import PrivateRoute, { Router } from '@Components/app-layout/PrivateRoute';

import OarganizationsGrid from '../components/Grid';
import { OrganizationProvider } from '../store';

import OrganizationFormLayout from './Form';

export default function OarganizationsGridLayout() {
  return <OrganizationProvider>
    <OarganizationsGrid />
    <Router>
      <PrivateRoute path={["/admin/organizations/add", "/admin/organizations/:id"]} component={OrganizationFormLayout} />
    </Router>
  </OrganizationProvider>;
}
